import script from "./CoordManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CoordManager.vue?vue&type=script&setup=true&lang=js"

import "./CoordManager.vue?vue&type=style&index=0&id=b14c4560&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b14c4560"]])

export default __exports__